var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h16zm0 1.5H4a.5.5 0 00-.492.41L3.5 6v12a.5.5 0 00.41.492L4 18.5h3.441a.76.76 0 01.029-.03l3.98-3.981a2.75 2.75 0 013.175-.515l1.421.71a1.25 1.25 0 001.443-.234l2.98-2.98.031-.028V6a.5.5 0 00-.41-.492L20 5.5zm.5 8.06l-1.95 1.951a2.75 2.75 0 01-3.175.515l-1.421-.71a1.25 1.25 0 00-1.443.234L9.56 18.5H20a.5.5 0 00.492-.41L20.5 18v-4.44z",
    fill: "currentColor"
  })));
}

export default SvgImage;